import { useQuery } from '@apollo/client/react';
import { WatchQueryFetchPolicy } from '@apollo/client';
import { TenantFeatureGatesEnum } from '../../constants/tenantFeatureGates';
import { GET_TENANT_FEATURE_GATES } from '@api/queries/getTenantFeatureGates';

export interface UseTenantFeatureGatesProps {
  tenantIds: string[];
  featureGateKeys: TenantFeatureGatesEnum[];
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
}

export const useTenantFeatureGates = ({
  tenantIds,
  featureGateKeys,
  skip = false,
  fetchPolicy = 'network-only',
}: UseTenantFeatureGatesProps) => {
  const { data, loading, error } = useQuery(GET_TENANT_FEATURE_GATES, {
    fetchPolicy,
    variables: { where: { tenantIds, featureGateKeys } },
    skip: skip || !tenantIds.length,
  });

  return {
    data,
    loading,
    error,
  };
};
